import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ServiceContractRythm } from '@work4all/models/lib/Enums/ServiceContractRythm.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function RythmStatusPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(ServiceContractRythm)
      .map((key) => {
        const id = ServiceContractRythm[key];

        return {
          id,
          name: t(`SERVICECONTRACT.RYTHMSTATUSES.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
